export default [
    {
        path: '/ImAd4RBolpPC',
        name: 'outstanding',
        meta: {
            title: 'Outstanding Payments',
            authRequired: true,
        },
        component: ()=> import('../views/payments/index')
    },
    {
        path: '/KtNchtIW0tzU',
        name: 'payments',
        meta: {
            title: 'Payments',
            authRequired: true,
        },
        component: () => import('../views/payments/payments') 
    },
    {
        path: '/FV1ZikX3tSC6',
        name: 'checkout',
        meta: {
            title: 'Checkout',
            authRequired: true,
        },
        component: () => import('../views/payments/checkout') 
    },
    {
        path: '/8gqCEJ02U8JJ',
        name: 'Successful',
        meta: {
            title: 'payment Success',
            authRequired: true,
        },
        component: () => import('../views/payments/success') 
    },
    {
        path: '/aStrJmuxSAr7',
        name: 'failed',
        meta: {
            title: 'Payment Failed ',
            authRequired: true,
        },
        component: () => import('../views/payments/failed') 
    },

]